module.exports = __webpack_public_path__ + "static/img/top_left.445159ea.png";